export const PANIC_KEYS = {
  ODT_PANIC_ACTIVATION: 'ODT_PANIC_ACTIVATION',
  ODT_PANIC_CASH_TRANSFER: 'ODT_PANIC_CASH_TRANSFER',
  ODT_PANIC_BUY_SELL: 'ODT_PANIC_BUY_SELL',
};
